import { storage } from "../../services/storageService";
import { StorageKeys } from "../../services/constants/StorageKeys";

export const findProvider = (providers, providerId) =>
  providers.find((provider) => provider.id === providerId);

// The short name where the provider has one, „László”, else the full name.
export const shortNameOf = (provider) => provider?.nickname || provider?.name;

/**
 * The guest's stored choice, `{ providerId }` with null for „Bárki”, or null when there is none.
 * A choice naming nobody in `providers` any more (a provider who left, another tenant's link) is
 * none either: the guest chooses again before any request carries it (docs/MULTI_PROVIDER.md).
 */
export const readProviderChoice = (providers) => {
  const choice = storage.get(StorageKeys.SELECTED_PROVIDER);
  if (!choice || choice.providerId === undefined) return null;
  if (choice.providerId !== null && !findProvider(providers, choice.providerId)) return null;
  return choice;
};

// A new choice drops the slot picked for the old one: its free list was another provider's.
export const saveProviderChoice = (providerId) => {
  storage.set(StorageKeys.SELECTED_PROVIDER, { providerId });
  storage.remove(StorageKeys.SELECTED_APPOINTMENT);
};
